import {FunctionComponent} from 'react';
import ServiceListContainer from './list/ServiceListContainer';

const ServiceContainer: FunctionComponent = () => {
  return (
    <>
      <ServiceListContainer />
    </>
  );
}

export default ServiceContainer;
